import { Container, Texture } from '../../../odie';

import { StatueBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const styles = [
  {
    asset: 'statue/block.statue.0.png',
    y: 38,
  },
  {
    asset: 'statue/block.statue.1.png',
    y: 38,
  },
  {
    asset: 'statue/block.statue.2.png',
    y: 38,
  },
];

/*
    statue block view
*/
export class StatueBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  private _sprite: FitWidthBlockSprite;
  private _count = 0;

  // properties
  //-------------------------------------------------------------------------
  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    const style = styles[value];

    // update field
    this._count = value;

    // update view texture based on count
    this._sprite.texture = Texture.from(style.asset);

    // position view based on count
    this.y = style.y;
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: StatueBlockProps) {
    // create base view
    super();
    this._sprite = new FitWidthBlockSprite(styles[0].asset, props);
    this.addChild(this._sprite);
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return styles.map((style) => style.asset);
  }
}
